<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">金币管理</p>
      <div class="content-input">
        <div class="content-input-item">
          <label>平台：</label>
          <el-select v-model="platformType" placeholder="Select" style="width: 7em" @change="platformChange">
            <el-option v-for="item in platformTypeArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>包名：</label>
          <el-select v-model="packageNameId" placeholder="Select" style="width: 10em" :disabled="platformType == -1">
            <el-option v-for="item in packageNameArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>状态：</label>
          <el-select v-model="state" placeholder="Select" style="width: 8em">
            <el-option v-for="item in stateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <ElButtons type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPage(true)"> 查询 </ElButtons>
          <!--          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>-->
        </div>
      </div>
    </div>
    <div class="content-main">
      <div class="content-button">
        <div>
          <el-button type="primary" @click="editGoldPriceDialog(-1)">添加</el-button>
        </div>
        <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
      </div>
      <div class="content-table">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            v-loading="listLoading"
            border
        >
          <el-table-column property="num" label="金币数量" v-if="checkColList.indexOf('金币数量') > -1" />
          <el-table-column property="" label="详情信息" v-if="checkColList.indexOf('详情信息') > -1" width="300">
            <template #default="scope">
              <p>渠道：{{scope.row.channel}}</p>
              <p>productId：{{scope.row.productId}}</p>
              <p>平台：{{ scope.row.platformType == 1?'安卓':scope.row.platformType ==2?'IOS':scope.row.platformType ===4?'鸿蒙':'' }}</p>
              <p>包名：{{scope.row.packageNameId == 0?'不限':scope.row.packageName}}</p>
            </template>
          </el-table-column>
          <el-table-column property="oldPrice" label="打折前价格" v-if="checkColList.indexOf('打折前价格') > -1"></el-table-column>
          <el-table-column property="newPrice" label="打折后价格" v-if="checkColList.indexOf('打折后价格') > -1"></el-table-column>
          <el-table-column property="discount" label="折扣" v-if="checkColList.indexOf('折扣') > -1"></el-table-column>
          <el-table-column property="" label="状态" v-if="checkColList.indexOf('状态') > -1">
            <template #default="scope">
              <p>{{scope.row.state==0?'生效':scope.row.state==1?'下架':'--'}}</p>
            </template>
          </el-table-column>
          <el-table-column property="" label="金币展示" v-if="checkColList.indexOf('金币展示') > -1">
            <template #default="scope">
              <p>{{scope.row.showType==1?'仅购买页面展示':scope.row.showType==2?'仅弹框展示':scope.row.showType==-1?'全部展示':'--'}}</p>
            </template>
          </el-table-column>
          <el-table-column property="orderNum" label="排列" v-if="checkColList.indexOf('排列') > -1"></el-table-column>
          <el-table-column property="" label="操作" v-if="checkColList.indexOf('操作') > -1">
            <template #default="scope">
              <el-button @click="editGoldPriceDialog(scope.$index,scope.row)" type="text">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import BtnGroup from '../../components/BtnGroup'
import { getGoldPricePageList, listPackageNameAndChannel } from '../../api/url'
import { getFormData } from '../../api/api'
import Dialog from "@/assets/js/dialog";
import GoldPriceDialog from "./components/GoldPriceDialog";

export default {
  name: "GoldPrice",
  components: { BtnGroup },
  data() {
    return {

      stateArray: [
        { label: '不限', value: -1 },
        { label: '生效', value: 0 },
        { label: '下架', value: 1 }
      ],
      state: 0,

      //刷新组
      colList: ['金币数量', '详情信息', '打折前价格', '打折后价格', '折扣', '状态', '金币展示', '排列', '操作'],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,

      searchLoading: false,
      listLoading: false,

      //平台
      platformTypeArray: [
        {label: "不限",value: -1},
        {label: "安卓",value: 1},
        {label: "IOS",value: 2},
        {label: "鸿蒙",value: 4}
      ],
      platformType: -1,

      //包名
      channelPackageList: [],
      packageNameArray: [
        {label: '全部', value: -1}
      ],
      packageNameId: -1,

    }
  },
  methods: {
    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    // 重置参数
    refreshParam() {
      this.searchType = 1;
      this.searchValue = ''
      this.getPage(true);
    },
    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['platformType'] = this.platformType;
      param['packageNameId'] = this.packageNameId;
      param['state'] = this.state;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getGoldPricePageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch(() => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    editGoldPriceDialog(idx, row) {
      let _title = '';
      let priceForm = {}
      if (idx > -1) {
        _title = '编辑金币套餐'
        priceForm = Object.assign({}, row);
      }else {
        _title = '添加金币套餐'
      }
      Dialog.open({
        title: _title,
        component: GoldPriceDialog,
        data: {
          priceForm: priceForm,
          channelPackageList: this.channelPackageList,
          ids: idx,
        },
        confirm: (result) => {
          this.getPage()
        }
      })
    },

    //包名、渠道
    getPackageChannelList() {
      getFormData(listPackageNameAndChannel).then((data)=>{
        let {msg, code} = data;
        if(code == 200) {
          this.channelPackageList = data.data;
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
      })
    },

    platformChange(val) {
      this.packageNameArray = [];
      this.packageNameArray.push({label: '全部', value: -1});
      this.packageNameArray.push({label: '不限', value: 0});
      if(val == -1) {
        this.packageNameId = -1
      } else {
        this.channelPackageList.map(item=>{
          if(item.platformType == val) {
            let obj = {}
            obj.label = item.packageName
            obj.value = item.id
            this.packageNameArray.push(obj)
          }
        })
      }  
    },


  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
    this.getPackageChannelList();
  }
}
</script>

<style scoped>

</style>
